<template>
  <tr v-if="projectType"
      :class="{'disabled': projectType.validUntil}"
      @dblclick="$router.push({name: 'projectTypeEdit', params: {id: projectType.id}})"
  >
    <td>
      <button v-if="projectType.validUntil === null"
              v-help.mouse="'Editovat typ projektu'"
              class="asd-btn-edit"
              @click="$router.push({name: 'projectTypeEdit', params: {id: projectType.id}})"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>
    </td>
    <td>
      <span v-if="projectType">
        {{ projectType.name }}
      </span>
    </td>
    <td>
      {{ projectType.validUntil | formatTimestamp }}
    </td>
    <td class="properties-names">
      <span v-for="pt in propertyTypes" :key="pt.id"
            v-help.mouse="pt.activeUntil !== null ? 'Tato vlastnost je deaktivována. Reaktivovat ji můžete v editaci vlastností.|Pokud jí jíž v tomto typu projektu nechcete musíte jí ručně odstranit.' : false"
            :class="{'disabled': pt.activeUntil !== null}"
      >
        {{ pt.name }},
      </span>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'
import ProjectTypeDataMixin from 'CORE/mixins/project-type-data'
import { czSorter } from 'CORE/utils/sorters'

export default {
    name: 'ProjectTypeRow',
    mixins: [
        ProjectTypeDataMixin,
    ],
    props: {
        projectTypeId: {
            type: String,
            required: true,
        },
    },
    computed: {
        propertyTypes() {
            let pt = _.get(this.projectType, 'propertyType', [])
            pt = _.sortWith(pt, (a, b) => czSorter('asc')(...[a, b].map(c => _.get(c, 'name'))))
            return pt
        },
    },
}
</script>
